import { useDispatch, useSelector } from "react-redux";
import Col from "../element/col";
import Row from "../element/row";
import Title from "./common.title";
import Container from "../element/container";
import Image from "../element/image";
import Icon from "../element/icon";
import formatNumber from "../../helpers/format.number";
import { useLocation, useNavigate } from "react-router-dom";
import Quantity from "../element/quantity";
import useWindowDimension from "../hook/use.window.dimension";
import {
  getCartInfo,
  removeCart,
  updateCart,
} from "../../redux/reducer/cart.reducer";
import { showToast } from "../../helpers/show.toast";
import { getCartCount } from "../../redux/reducer/common.reducer";
import { Skeleton } from "primereact/skeleton";

export default function CommonCart({ data, key, order, type, loading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowDimension();
  const { removeCartLoading } = useSelector((state) => state.cart);

  const getVariantOption = (options) => {
    if (options?.length > 0) {
      const formattedValues = options.map((opt) => {
        return opt.value;
      });

      return formattedValues.join(" | ");
    }
  };

  const handleRemoveItem = (id) => {
    if (removeCartLoading) {
      return;
    }

    dispatch(
      removeCart({
        id: id,
        quantity: 0,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(getCartInfo());
        dispatch(getCartCount())
          .unwrap()
          .then((res) => {
            if (pathname === "/cart" && res.data === 0) {
              navigate("/shop/all");
              showToast(
                "Your cart is empty!",
                "Add something to your cart before checkout.",
                "error"
              );
              return;
            } else {
              showToast(
                "Cart updated!",
                "The cart item quantity is updated successful.",
                "success"
              );
            }
          });
      });
  };

  return (
    <Row className={`common-cart ${order ? "--order" : ""}`} key={key}>
      {loading ? (
        <Skeleton
          width={width < 991 ? "70px" : width < 991 ? "90px" : "110px"}
          height={width < 991 ? "70px" : width < 991 ? "90px" : "110px"}
          borderRadius="0"
          className="_img"
        />
      ) : (
        <Image
          src={data.media?.length > 0 && data.media[0].url}
          className="_img"
        />
      )}
      <Col className={`w-100 v-flex ${order ? "gap-2" : "gap-4"}`}>
        <Row
          className={`w-100 ${
            width > 500 ? "v-flex" : "v-flex"
          } flex-nowrap justify-between items-baseline gap-2`}
        >
          <Row className="h-flex justify-between w-100">
            {loading ? (
              <>
                <Skeleton width="160px" height="20px" borderRadius="0" />
                <Skeleton
                  width="80px"
                  height={width < 500 ? "16px" : "20px"}
                  borderRadius="0"
                />
              </>
            ) : (
              <>
                <h3>{data.product?.name?.name || data.product_name}</h3>
                <h4>
                  RM
                  {order
                    ? data.product_price
                    : formatNumber(data.price, "decimal")}
                </h4>
              </>
            )}
          </Row>
          <Row className="h-flex justify-between w-100">
            <Row>
              {loading ? (
                <Skeleton
                  width="60px"
                  height={width < 500 ? "13px" : "15px"}
                  borderRadius="0"
                  className="mt-1"
                />
              ) : (
                (data.variant?.option_values?.length > 0 ||
                  data.variant?.length > 0) && (
                  <p className="text-capitalize">
                    {getVariantOption(
                      data.variant.option_values || data.variant
                    )}
                  </p>
                )
              )}
            </Row>
            {order && <p>x{data.quantity}</p>}
          </Row>
        </Row>
        {!order && (
          <Row className="h-flex justify-between">
            {loading ? (
              <Skeleton
                width="150px"
                height="32px"
                borderRadius="0"
                // className="mt-1"
              />
            ) : (
              <>
                <Quantity
                  id={data.id}
                  max={data.variant?.quantity}
                  quantity={data.quantity}
                  type={type}
                  handleRemoveItem={handleRemoveItem}
                  small
                />
                <Icon
                  icon="mdi:bin"
                  className="_svg remove pointer"
                  onClick={() => handleRemoveItem(data.id)}
                />
              </>
            )}
          </Row>
        )}
      </Col>
    </Row>
  );
}
